export type Tree = {
    [index: string]: Tree;
}

export function keyExistsDeep(obj, targetKey) {
    if (typeof obj !== 'object' || obj === null) return false;

    if (obj.hasOwnProperty(targetKey)) return true;

    for (const key in obj) {
        if (keyExistsDeep(obj[key], targetKey)) {
            return true;
        }
    }

    return false;
}

export function getStorageTree(storageKey: string): Tree {
    const localStorageValue = window.localStorage.getItem(storageKey);
    return JSON.parse(localStorageValue ?? '{}');
}

export function storeUnfoldedItems(storageKey: string, path: string): void {
    const storageTree = getStorageTree(storageKey);
    const itemsToAdd = pathToArray(path);

    const updatedStorageTree = recursivelyAppendItems(storageTree, itemsToAdd);

    setTreeInStorage(storageKey, updatedStorageTree);
}

export function storeFoldedItems(storageKey: string, path: string): void {
    const storageTree = getStorageTree(storageKey);
    const itemsToRemove = pathToArray(path);

    const updatedStorageTree = recursivelyRemoveItems(storageTree, itemsToRemove[itemsToRemove.length - 1]);

    setTreeInStorage(storageKey, updatedStorageTree);
}

function setTreeInStorage(keySuffix: string, tree: Tree): void {
    window.localStorage.setItem(keySuffix, JSON.stringify(tree));
}

function pathToArray(path: string): string[] {
    return path.split('/').filter(el => el !== '');
}

function recursivelyAppendItems(tree: Tree, itemsToAdd: string[]): Tree {
    if (itemsToAdd.length === 0) {
        return tree;
    }

    const itemToAdd = itemsToAdd.shift();

    if (typeof tree[itemToAdd] === 'undefined') {
        tree[itemToAdd] = {};
    }

    tree[itemToAdd] = recursivelyAppendItems(tree[itemToAdd], itemsToAdd);

    return tree;
}

function recursivelyRemoveItems(tree: Tree, itemToRemove: string): Tree {
    if (tree.hasOwnProperty(itemToRemove)) {
        delete tree[itemToRemove];
        return tree;
    }

    for (const node in tree) {
        tree[node] = recursivelyRemoveItems(tree[node], itemToRemove);
    }

    return tree;
}
